import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/correctionSemiProducts';
import { post, get } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getSemiProductByReady({ payload }) {
  try {
    const response = yield call(post, '/grid/production/semi_product/by_ready', payload);
    yield put(action.getSemiProductByReadySuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getSemiProductByReadyFail());
  }
}

export function* getCorrectionSemi({ payload }) {
  try {
    const response = yield call(get, `/grid/production/correction/semi_product?operationNumId=${payload.operationNumId}&taskId=${payload.taskId}`);
    yield put(action.getCorrectionSemiSuccess(response));
  } catch (error) {
    yield put(action.getCorrectionSemiFail());
  }
}
